package system.single

import b2d.*
import com.github.quillraven.fleks.*
import com.github.quillraven.fleks.World.Companion.family
import com.github.quillraven.fleks.World.Companion.inject
import com.soywiz.korma.geom.*
import component.*
import input.*

class AbilitySelectionSystem(
    worldMetaData: WorldMetaData = inject(),
    private val selectFun: AbilitySelector.(Abilities, Abilities) -> Unit
) : IteratingSystem(family { all(PlayerComponent, PhysicComponent) }) {

//    private val firstPoint = worldMetaData.firstAbilitySelectionPoint
    private val firstPoint = Point()
    private val secondPoint = Point()
//    private val secondPoint = worldMetaData.secondAbilitySelectionPoint

    private var isFirstReached = false
    private var isSecondReached = false

    private var isFirstShowed = false
    private var isSecondShowed = false

    override fun onTickEntity(entity: Entity) {
        val physComp = entity[PhysicComponent]
        if (!isFirstReached &&
            physComp.body.position.x >= firstPoint.x.toFloat()
        ) {
            isFirstReached = true
        }

        if (!isSecondReached &&
            physComp.body.position.x >= secondPoint.x.toFloat()
        ) {
            isSecondReached = true
        }

        val playerComp = entity[PlayerComponent]
        val abilitySelector = playerComp.abilitySelector

        if (isFirstReached && !abilitySelector.isFirstSelected && !isFirstShowed) {
            isFirstShowed = true
            abilitySelector.selectFun(Abilities.TRAP, Abilities.FIRE_BOLT)
        }

        if (isSecondReached && !abilitySelector.isSecondSelected && !isSecondShowed) {
            isSecondShowed = true
            abilitySelector.selectFun(Abilities.TRAP, Abilities.FROST_BOLT)
        }
    }
}

class AbilitySelector(
    val firstAbilityButton: AbilityButton,
    val secondAbilityButton: AbilityButton,
) {

    var firstAbility = Abilities.NONE
        private set
    val isFirstSelected: Boolean
        get() = firstAbility != Abilities.NONE

    var firstAbilityCooldowner: AbilityCooldowner = AbilityCooldowner.DISABLED
        private set

    var secondAbility = Abilities.NONE
        private set

    val isSecondSelected: Boolean
        get() = secondAbility != Abilities.NONE

    var secondAbilityCooldowner: AbilityCooldowner = AbilityCooldowner.DISABLED
        private set

    init {
        firstAbilityButton.text.text = firstAbility.name.substring(0, 2)
        firstAbilityButton.visibility = false

        secondAbilityButton.text.text = secondAbility.name.substring(0, 2)
        secondAbilityButton.visibility = false
    }

    fun selectAbility(ability: Abilities) {
        if (!isFirstSelected) {
            firstAbility = ability
            firstAbilityButton.text.text = firstAbility.name.substring(0, 2)
            firstAbilityButton.visibility = true
            firstAbilityCooldowner = AbilityCooldowner(2.0f)
            println("${firstAbility.name} selected")
            return
        }

        if (!isSecondSelected) {
            secondAbility = ability
            secondAbilityButton.text.text = secondAbility.name.substring(0, 2)
            secondAbilityButton.visibility = true
            secondAbilityCooldowner = AbilityCooldowner(2.0f)
            println("${secondAbility.name} selected")
            return
        }
    }
}

class AbilityCooldowner(
    val refreshTimeSeconds: Float = 1.0f
) {
    companion object {
        val DISABLED = AbilityCooldowner(-1.0f)
    }

    var wasUsed = false
        private set
    var elapsedTime = 0.0f

    val isReady: Boolean
        get() = !wasUsed && elapsedTime == 0.0f

    fun useAbility() {
        wasUsed = true
        elapsedTime = 0.0f
    }

    fun reset() {
        wasUsed = false
        elapsedTime = 0.0f
    }
}
